import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const RoomUtilizationIcon = (props: SvgProps) => <Svg
  width={16}
  height={16}
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M6 2H10M6 2H2V6M6 2V14M10 2H14V6M10 2V14M6 14H2V10M6 14H10M10 14H14V10M2 6V10M2 6H14M2 10H14M14 10V6'
    stroke='#3379BD'
    strokeWidth='1.5'
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default RoomUtilizationIcon;
